import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-svg-caissepalette',
    templateUrl: './svg-caissepalette.component.html',
    styleUrls: ['./svg-caissepalette.component.css'],
    standalone: false
})
export class SvgCaissepaletteComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
